(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["synergy-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('synergy-carousel')) {
    customElements.define('synergy-carousel', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-carousel-viewport]');
        this.slides = [...this.querySelectorAll('[data-carousel-slide]')];
        this.previous = this.querySelector('[data-carousel-previous]');
        this.next = this.querySelector('[data-carousel-next]');
        this.status = this.querySelector('[data-carousel-status]');
        if (!this.viewport || this.slides.length === 0) return;
        this.previous.addEventListener('click', () => this.move(-1));
        this.next.addEventListener('click', () => this.move(1));
        this.viewport.addEventListener('scroll', () => this.update(), { passive: true });
        new ResizeObserver(() => this.update()).observe(this.viewport);
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.update();
        this.start();
      }
      move(direction) {
        const slide = this.slides[0];
        const gap = parseFloat(getComputedStyle(this.querySelector('.synergy-carousel__track')).gap) || 0;
        this.viewport.scrollBy({ left: direction * (slide.getBoundingClientRect().width + gap), behavior: 'smooth' });
      }
      update() {
        const max = this.viewport.scrollWidth - this.viewport.clientWidth;
        const scrollable = max > 2;
        this.querySelector('.synergy-carousel__controls').hidden = !scrollable;
        this.previous.disabled = this.viewport.scrollLeft <= 2;
        this.next.disabled = this.viewport.scrollLeft >= max - 2;
        const firstWidth = this.slides[0].getBoundingClientRect().width || 1;
        const current = Math.min(this.slides.length, Math.round(this.viewport.scrollLeft / firstWidth) + 1);
        this.status.textContent = `${current} / ${this.slides.length}`;
      }
      start() {
        if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.stop();
        this.timer = window.setInterval(() => {
          const max = this.viewport.scrollWidth - this.viewport.clientWidth;
          if (this.viewport.scrollLeft >= max - 2) {
            this.viewport.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            this.move(1);
          }
        }, Number(this.dataset.speed) || 5000);
      }
      stop() {
        if (this.timer) window.clearInterval(this.timer);
      }
      disconnectedCallback() {
        this.stop();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
